import React from 'react'

const FilterSetting = () => {
  return (
    <div>FilterSetting</div>
  )
}

export default FilterSetting